import { z } from 'zod';

/** Logged-in sponsor registers a new downline member (E1/E2/E3 package, binary placement). */
export const RegisterMemberSchema = z
  .object({
    /** E1=100$, E2=1000$, E3=10000$ (E3 requires registration.e3_enabled). */
    star_package: z.enum(['E1', 'E2', 'E3']).default('E2'),
    username: z
      .string({ required_error: '请填写用户名' })
      .min(3, '用户名至少 3 个字符')
      .max(32, '用户名不能超过 32 个字符')
      .regex(/^[a-zA-Z0-9_.]+$/, '用户名仅支持英文字母、数字、下划线和点'),
    email: z
      .string()
      .email('邮箱格式不正确')
      .max(128, '邮箱不能超过 128 个字符')
      .optional(),
    phone: z.string().min(7, '手机号至少 7 位').max(20, '手机号不能超过 20 位').optional(),
    password: z
      .string({ required_error: '请填写密码' })
      .min(8, '密码至少 8 位')
      .max(128, '密码不能超过 128 位')
      .regex(/[A-Z]/, '密码须包含至少一个大写字母')
      .regex(/[a-z]/, '密码须包含至少一个小写字母')
      .regex(/[0-9]/, '密码须包含至少一个数字'),
    password_confirm: z.string({ required_error: '请确认密码' }),
    position: z.enum(['L', 'R'], { required_error: '请选择左区或右区安置' }),
    /** Binary-tree node to start placement from (defaults to sponsor). Must be sponsor or downline. */
    placement_user_id: z.number().int().positive('安置节点无效').optional(),
  })
  .refine((v) => v.password === v.password_confirm, {
    path: ['password_confirm'],
    message: '两次输入的密码不一致',
  });

export type RegisterMemberRequest = z.infer<typeof RegisterMemberSchema>;
